import { noop } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { hitSlop } from 'design-system';
import Text from 'design-system/Text';
import { useActionSheet } from 'hooks/useActionSheet';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const accountHelpButtonStrings = {
    title: 'How can we help you?',
    options: {
        helpCenter: 'Visit the help center',
        chat: 'Chat to a human',
        pendingTopups: 'My deposit is still pending',
        cancel: 'Cancel',
    },
};
const ContactSupportTextButton = ({ title, showPendingDepositHelp, ...props }) => {
    const { showActionSheetWithOptions } = useActionSheet();
    const navigation = useMainStackNavigation();
    const sheetOptions = useMemo(() => {
        const options = [
            {
                title: accountHelpButtonStrings.options.helpCenter,
                action: Links.openEmmaHelp,
            },
            {
                title: accountHelpButtonStrings.options.chat,
                action: () => navigation.navigateDeprecated('Support', {}),
            },
            { title: accountHelpButtonStrings.options.cancel, action: noop },
        ];
        if (showPendingDepositHelp) {
            options.unshift({
                title: accountHelpButtonStrings.options.pendingTopups,
                action: Links.openPendingDepositHelp,
            });
        }
        return options;
    }, [showPendingDepositHelp]);
    const handlePress = useCallback(() => {
        showActionSheetWithOptions({
            options: sheetOptions.map((o) => o.title),
            title: accountHelpButtonStrings.title,
            cancelButtonIndex: sheetOptions.length - 1,
        }, (i) => {
            if (i !== undefined) {
                sheetOptions[i].action();
            }
        });
    }, [sheetOptions, showActionSheetWithOptions]);
    return (<View style={styles.container}>
      <TouchableOpacity onPress={handlePress} hitSlop={hitSlop}>
        <Text {...(props || { 'Text-14': true })}>
          {title ? `${title} ` : ''}
          <Text {...(props || { 'Text-14': true })} Primary>
            Contact support
          </Text>
        </Text>
      </TouchableOpacity>
    </View>);
};
export default ContactSupportTextButton;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
});
